import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { CREATE_ENTRY_STRATEGY } from './actionTypes';
import { createEntryStrategySuccessful, createEntryStrategyFailed } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

// Is user register successfull then direct plot user in redux.
function* createEntryStrategy({ payload: { entryStrategy, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.createEntryStrategy, {
      token: entryStrategy.token,
      name: entryStrategy.name,
    });
    yield put(createEntryStrategySuccessful(response.message));
    if (response && response.id && history) {
      // Simulamos la estructura de la estrategia recién creada para el componente receptor
      const newStrategyMock = {
        id: response.id,
        name: entryStrategy.name,
        active: '1', // Empieza activa por defecto
        areas: '[]', // Empieza sin áreas asignadas
      };

      history.push({
        pathname: `/entry-strategy/${response.id}`,
        state: newStrategyMock, // Pasamos el state exactamente como lo hace el listado principal
      });
    }
  } catch (error) {
    yield put(createEntryStrategyFailed(error));
  }
}

export function* watchEntryStrategyCreate() {
  yield takeEvery(CREATE_ENTRY_STRATEGY, createEntryStrategy);
}

function* createEntryStrategySaga() {
  yield all([fork(watchEntryStrategyCreate)]);
}

export default createEntryStrategySaga;
